// 热更新
import { ElMessageBox } from 'element-plus'

let lastScripts = []
async function extractNewScripts(html) {
	const scripReg = /<script.*src=["'](?<src>[^"']+)/gm //匹配script标签并捕获src属性内的URL
	const result = []
	let match
	while ((match = scripReg.exec(html))) {
		result.push(match.groups?.src ?? '')
	}
	return result
}

/* 判断浏览器是否需要更新数据 */
async function needUpdate() {
  //获取当前页面的script标签src属性
	const newScripts = await extractNewScripts(await fetch('/').then((resp) => resp.text()))
  //如果是第一次加载，则不更新
	if (!lastScripts.length) {
		lastScripts = newScripts
		return false
	}
  //判断是否需要更新 长度不同-更新
	if (newScripts.length !== lastScripts.length) {
		lastScripts = newScripts
		return true
	}
  //比较两个数组是否相等 长度相同，内容不同-更新
	for (let i = 0; i < lastScripts.length; i++) {
		if (lastScripts[i] !== newScripts[i]) {
			lastScripts = newScripts
			return true
		}
	}
	return false
}

/* 延时时间20s */
const DURATION = 20 * 1000;
 
/* 自动刷新 */
export const autoRefresh = () => {
  
	setTimeout(async () => {
		const willUpdate = await needUpdate();
		if (willUpdate) {
			ElMessageBox.confirm('页面有更新，点击确定刷新页面?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					location.reload();
				})
				.catch(() => {});
		} else {
			autoRefresh(); // 如果不需要更新数据，继续执行下一次判断
		}
	}, DURATION);
};
